// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__ITMAC","row":"ProcedureTreatmentSummary_row__1iyH5"};